import React from 'react';
import Style from './style.module.css';
import PreviewStyle from './preview.module.css';

const CtaCard: React.FC<{
  Icon: React.FC;
  textStyle?: React.CSSProperties;
  text: string;
  onClick: () => void;
  preview?: boolean;
  isMobile?: boolean;
  id?: string;
}> = ({ Icon, text, onClick, preview, isMobile, textStyle, id }) => {
  let currentStyle;
  let fontSize;
  if (preview) {
    currentStyle = PreviewStyle;
    if (isMobile) {
      fontSize = 8;
    } else {
      fontSize = 5;
    }
  } else {
    currentStyle = Style;
    fontSize = 12;
  }
  return (
    <button className={currentStyle.card} onClick={() => onClick()} id={id}>
      <Icon />
      <p style={{ ...textStyle, fontSize }} className={currentStyle.cardText}>
        {text}
      </p>
    </button>
  );
};

export default CtaCard;
